import React, { Component } from 'react';
import { Col, FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap';

import { updateOtherInfo } from '../actions';
import { foreignLanguages } from '../config/constants';

class ForeignLanguage extends Component {
  constructor(props){
    super(props);
    this.handleOtherLanguageNameChange = this.handleOtherLanguageNameChange.bind(this);
    this.handleLanguageToggle = this.handleLanguageToggle.bind(this);
  }

  handleOtherLanguageNameChange(e){
    const updates = {
      foreignLanguage: {
        ...this.props.foreignLanguage,
        otherLanguage: e.target.value
      }
    };
    this.props.dispatch(updateOtherInfo(updates));
  }

  handleLanguageToggle(e){
    const key = e.target.value;
    const newValue = !this.props.foreignLanguage[key];
    const updates = {
      foreignLanguage: {
        ...this.props.foreignLanguage
      }
    };

    updates.foreignLanguage[key] = newValue;
    // DynamoDB hates empty strings so we delete the attribute when not used
    if(key === 'other') {
      if(newValue)
          updates.foreignLanguage.otherLanguage = '';
        else
          delete updates.foreignLanguage.otherLanguage;
    }
    this.props.dispatch(updateOtherInfo(updates));
  }

  render() {
    const { other, otherLanguage } = this.props.foreignLanguage;

    const mapForeignLanguages = () => {
      return Object.keys(foreignLanguages).map((language) => {
        return (
          <Checkbox checked={this.props.foreignLanguage[language]} key={language} value={language} onChange={this.handleLanguageToggle}>{foreignLanguages[language]}</Checkbox>
        )
      });
    };

    const mappedLanguages = mapForeignLanguages();

    return (
      <div>
        <FormGroup>
          <Col md={12}>
            <ControlLabel>Foreign Language</ControlLabel>
          </Col>
          <Col md={6}>
            {mappedLanguages.map((language, index) => index % 2 === 0 ? language : null)}
          </Col>
          <Col md={6}>
            {mappedLanguages.map((language, index) => index % 2 === 1 ? language : null)}
          </Col>
        </FormGroup>
        {other &&
        <FormGroup controlId="other-language">
          <Col md={12}>
            <p>Please specify the other language.</p>
            <FormControl
              componentClass="input"
              type="text"
              value={otherLanguage}
              placeholder="Enter Language"
              onChange={this.handleOtherLanguageNameChange}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
        }
      </div>)
  }
}

export default ForeignLanguage;